module.exports = __webpack_public_path__ + "static/media/hand-pointer.f2ab0593.svg";